var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProductionTabs',{attrs:{"tabName":"DisplayCouverturesOnShelf"}}),_c('DisplayCouvertures',{attrs:{"title":"Kuwertury"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }